import styled, { css } from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';


const StyledButton = styled.button`

    border-radius: 20px;
    background: white;
    border: ${(props) => (props.color) ? `1px solid ${props.color}` : '1px solid #000'};
    color: ${(props) => (props.color) ? `${props.color}` : '#000'};
  /*  box-shadow: 0 3px 2px #A826EE;    */
    line-height: normal;
    outline:0;
    transition: all .15s ease-out;
    padding: 8px 19px;
    font-size: 14px;
    font-weight: bold;
    display: block;
    margin-top: 20px;

    ${(props) => props.centered && css`
        margin: 20px auto 0;
    `}

    ${(props) => props.disabled && css`
       border: 1px solid #848484;
       color: #848484;
       box-shadow: none;
       cursor: not-allowed;
    `}

    &:not(:disabled):hover{
      cursor: pointer;
    }

/*
    &:not(:disabled):hover{
        background: #FFE500;
        color: white !important;
    }
*/
`;


const RoundedButton = (props) => <StyledButton onClick={props.onTouchTap} {...props}>{props.label}</StyledButton>;

RoundedButton.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.string.isRequired,
  ]),
  onTouchTap: PropTypes.func,
};

export default RoundedButton;
